import React from 'react';
import InspectorCard from './inspector_card';
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css';

const availabilityString = availability => {
  if(availability === 'partial') {
    return "Partially Available";
  } else {
    return "Fully Available";
  }
}

const teacherTooltip = teacher => (
  <div className="abl-staff-details">
    <table className="abl-staff-details-table">
      <tbody>
        <tr>
          <th>Name:</th>
          <td>{teacher.name}</td>
        </tr>
        <tr>
          <th>FTE:</th>
          <td>.75</td>
        </tr>
        <tr>
          <th>Content Preps:</th>
          <td>3</td>
        </tr>
        <tr>
          <th>Availability:</th>
          <td>50%</td>
        </tr>
      </tbody>
    </table>
  </div>
)

export default function StaffAvailability(props) {
  let teachers = props.teachers.map((teacher, i) => (
      <li key={i}>
        <div className="abl-staff-member">
          <Tooltip placement="left" mouseEnterDelay={0.8} overlay={<span>{availabilityString(teacher.availability)}</span>}>
            <i className={`fa fa-circle availability-indicator availability-indicator-${teacher.availability}`}></i>
          </Tooltip>
          <Tooltip placement="bottom" mouseEnterDelay={0.8} overlay={teacherTooltip(teacher)}>
            <span className="abl-staff-name">{teacher.displayName}</span>
          </Tooltip>
          <span className="abl-staff-assign">
            <Tooltip placement="left" mouseEnterDelay={0.8} overlay={<span>Assign</span>}>
              <i className="fa fa-plus-circle"></i>
            </Tooltip>
          </span>
        </div>
      </li>
    )
  );

	return (
		<InspectorCard header="Staff Availability" {...props}>
      <div className="abl-inspector-group">
        <ul className="abl-available-staff-list">
          {teachers}
        </ul>
      </div>
    </InspectorCard>
	);
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule_inspector/staff_availability_card.js
 **/